// © 2026 Camp Promethean, LLC. All Rights Reserved.

import type { ReactNode } from "react";
import { AgoraComingSoonTooltipContent, AGORA_COMING_SOON_TOAST } from "@/content/agoraComingSoon";
import { AncoraComingSoonTooltipContent, ANCORA_COMING_SOON_TOAST } from "@/content/ancoraComingSoon";

export function comingSoonToastForPath(path: string): string {
  if (path === "/ancora" || path.startsWith("/ancora/")) {
    return ANCORA_COMING_SOON_TOAST;
  }
  if (path === "/agora" || path.startsWith("/agora/")) {
    return AGORA_COMING_SOON_TOAST;
  }
  return "This module is coming soon.";
}

export function ComingSoonTooltipForModule({ moduleId }: { moduleId: string }): ReactNode {
  if (moduleId === "ancora") return <AncoraComingSoonTooltipContent />;
  if (moduleId === "agora") return <AgoraComingSoonTooltipContent />;
  return null;
}
